import { default as UUID } from "node-uuid"
import { SCALAR_TYPES } from "src/libs/scalars"
import { CARD_FIELD_TYPE, CardFiled, FeaturesContent, ICard, ILandingSection, LANDING_TYPE_CONTENT, PersonalFields } from "src/modules/pe-landing-module/data/interfaces"
import Cards from "./Cards"
import Dummy from "./Dummy"

/* Protopia Ecosystem component */
export interface IPersonsProps {
   section:ILandingSection
   data: FeaturesContent
} 

// Dictionary for used card fields type 
export const FeateresFieldType  = (): any => ({
    canvas: CARD_FIELD_TYPE.CANVAS,
    time: CARD_FIELD_TYPE.TIME,
    icon : CARD_FIELD_TYPE.IMAGE,
    iconMedallion :CARD_FIELD_TYPE.MEDALLION,
    title : SCALAR_TYPES.TITLE,
    description : SCALAR_TYPES.HTML,
    links : CARD_FIELD_TYPE.PERSONAL_LINKS,
    button : CARD_FIELD_TYPE.INNER_LINK || CARD_FIELD_TYPE.OUTER_LINK,
    divider : CARD_FIELD_TYPE.DIVIDER,
    statistic_line: CARD_FIELD_TYPE.STATISTIC_LINE,
    checkbox: CARD_FIELD_TYPE.CHECK_BOX,
    speech_bubble: CARD_FIELD_TYPE.SPEECH_BUBBLE,
    person : CARD_FIELD_TYPE.PERSON,
    order : CARD_FIELD_TYPE.ORDER,
})

const Features = (props: IPersonsProps): JSX.Element => {
    const {data, section} = props
    const {order, cards, card_fields} = data
    
    const getCardFields = ( card_fields: PersonalFields ) : CardFiled[] => {
        let arr: any[] = order.map((key: keyof PersonalFields) => { 
            const field: CardFiled = {
                id: UUID.v4(),
                ...card_fields[key],
                type: FeateresFieldType()[key],
                pseudonym: key
            }            
            return field
        })
        return arr
    }
    const getCards = (): ICard[] => {
        let arr: [] = cards.map(( card: any, i:number ) => { 
            return {
                i,
                ...card,
                value: order.map((o, ii) => ({
                    id: o + "-" + i + "-" + ii,
                    ...card[o]
                }))
            }
        }) 
        return arr
    }
    const getData = ( card_fields: PersonalFields ): any => {
        const personalLinkType: any = {
            ...data,
            card_fields: getCardFields( card_fields ),
            cards: getCards()
        }
        return personalLinkType
    } 
    return !!Object.keys(order || {}).length
        ?
        <Cards 
            section={section}
            data={ getData( card_fields || {} ) }
        />
        :
        <Dummy {...{  
            ...{
                data: {
                    ...data as any,  
                    type: LANDING_TYPE_CONTENT.FEATURES_CARDS,
                    className: ` ${data.className} landing-html-${props.section.id} `
                },
            },
            ...props as any,
        }} />
}
export default Features